<template>
	<div>
		<ts-loading-banner :loading="waiting">
			<table class="table ui-table table-hover">
				<thead>
					<tr>
						<th style="width:14%">
							{{
								$t('inventory.operation.stock_count_entry.barcode')
							}} <span class="ts-text-red-500">*</span>
						</th>
						<th style="width:18%">
							{{
								$t('inventory.operation.stock_count_entry.product')
							}}
							<span class="ts-text-red-500">*</span>
						</th>
						<th style="width:100px">
							{{
								$t('inventory.operation.stock_count_entry.uom')
							}}
							<span class="ts-text-red-500">*</span>
						</th>
						<th class="text-center" style="width:9%">
							{{
								$t(
									'inventory.operation.stock_count_entry.system_qty'
								)
							}}
						</th>
						<th style="width:9%">
							{{
								$t(
									'inventory.operation.stock_count_entry.count_qty'
								)
							}}
							<span class="ts-text-red-500">*</span>
						</th>
						<th style="width:9%">
							{{
								$t(
									'inventory.operation.stock_count_entry.difference_quantity'
								)
							}}
						</th>
						<th style="width:15%">
							{{
								$t('inventory.operation.stock_count_entry.reason')
							}}
						</th>
						<th style="width: 2%" class="text-center">
							<a href="#" class="text-primary">
								<i class="fa fa-plus" @click.prevent="addNewRow"></i>
							</a>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in model.details" :key="index">
						<td>
							<ts-search-select v-model="item.barcode" :options="productNotIncludeSelected({
								addedProducts: model.details,
								excludeProductId: item.product_id
							}).map(el => ({
								value: el.barcode,
								text: el.barcode
							}))
								" :filterFunction="filterProductFunction" @change="barcodeChange(item)"></ts-search-select>
						</td>
						<td>
							<ts-search-select v-model="item.product_id" :options="productNotIncludeSelected({
								addedProducts: model.details,
								excludeProductId: item.product_id
							}).map(el => ({
								value: el.product_id,
								text: el.product_name_en
							}))
								" :filterFunction="filterProductFunction" @change="productChange(item)"></ts-search-select>
							<div class="validate" v-if="
								errors.has('details.' + index + '.product_id')
							">
								{{
									errors.first('details.' + index + '.product_id')
								}}
							</div>
						</td>
						<td>
							<a-select v-model="item.uom_id" :options="getUomByProduct(item.product_id)"></a-select>
							<div class="validate" v-if="
								errors.has('details.' + index + '.uom_id')
							">
								{{
									errors.first('details.' + index + '.uom_id')
								}}
							</div>
						</td>
						<td>
							<input type="number" v-model.number="item.system_qty" class="form-control only-border-bottom" readonly />
						</td>
						<td>
							<input type="number" v-model.number="item.count_qty" class="form-control only-border-bottom" :class="{
								'is-invalid': errors.has(
									'details.' + index + '.count_qty'
								)
							}" />
							<div class="invalid-feedback" v-if="errors.has('details.' + index + '.count_qty')">
								{{
									errors.first('details.' + index + '.count_qty')
								}}
							</div>
						</td>
						<td>
							<input type="number" v-model.number="item.different_qty" class="form-control only-border-bottom"
								readonly />
						</td>
						<td>
							<input type="text" v-model="item.reason" class="form-control only-border-bottom" :class="{
								'is-invalid': errors.has(
									'details.' + index + '.reason'
								)
							}" />
							<div class="invalid-feedback" v-if="errors.has('details.' + index + '.reason')">
								{{ errors.first('details.' + index + '.reason') }}
							</div>
						</td>
						<td class="text-center">
							<a href="#" class="text-danger" @click.prevent="removeRow(item)">
								<i class="fa fa-trash"></i>
							</a>
						</td>
					</tr>
				</tbody>
			</table>
		</ts-loading-banner>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
	name: 'itemDetail',
	props: ['value'],
	data() {
		return {
			errors: new Errors(),
			waiting: false,
			model: {},
			newRow: {
				stock_count_detail_id: 0,
				barcode: '',
				product_id: '',
				uom_id: '',
				system_qty: '',
				count_qty: '',
				different_qty: '',
				reason: ''
			},
		}
	},
	computed: {
		...mapState('stockCountEntry', ['products']),
		...mapGetters('stockCountEntry', ['productNotIncludeSelected', 'getUomByProduct'])
	},
	created() {
		this.model = this.value
	},
	methods: {
		addNewRow() {
			this.model.details.push(_.clone(this.newRow))
		},
		removeRow(item) {
			this.model.details.splice(this.model.details.indexOf(item), 1)
		},
		filterProductFunction(search, options) {
			return options.filter(option => {
				option = typeof option === 'object' ? option.text : option

				return option.toLowerCase().includes(search.toLowerCase())
			})
		},
		getSystemQty(row) {
			this.waiting = true
			this.$store
				.dispatch('stockCountEntry/getSystemQty', row.product_id)
				.then(response => {
					row.system_qty = row.count_qty = parseFloat(response.balance)
				})
				.catch(error => {
					this.$toasted.info(error.message)
				})
				.finally(() => this.waiting = false)
		},
		barcodeChange(item) {
			if (!item.barcode) {
				item.product_id = ''
				item.system_qty = 0
				return
			}
			let result = this.products.filter(p => p.barcode == item.barcode)
			item.product_id = result[0].product_id
			this.getSystemQty(item)
			this.setDefaultUom(item)
		},
		productChange(item) {
			if (!item.product_id) {
				item.barcode = ''
				item.system_qty = 0
				return
			} else {
				let result = this.products.filter(p => p.product_id == item.product_id)
				item.barcode = result[0].barcode
				this.getSystemQty(item)
				this.setDefaultUom(item)
			}
		},
		setDefaultUom(item) {
			const uom = this.getUomByProduct(item.product_id)
			if (uom.length) {
				const findDefault = uom.find(u => u.is_default)
				if (findDefault) {
					item.uom_id = findDefault.value
				}
			}
		}
	},
	watch: {
		'model.details': {
			handler() {
				this.model.details.map(el => {
					el.different_qty = el.count_qty - el.system_qty
				})
			},
			deep: true
		}
	},
}
</script>